import React from 'react';

export const ContainerClassNameContext = React.createContext('');
